<template>
  <div class="appNav-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item title="监控源" name="1">
          <div class="setting-item clearFloat mb16">
            <div style="display: flex; align-items: center">
              <div class="mr16" style="width: 20%">监控ID</div>
              <el-input style="flex: 1" v-model="cameraUrlId" />
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
let selectData = null
export default {
  name: "appNav-options-setting",
  props: { options: Object },
  data() {
    return {
      activeNames: [],
      loading: false
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    cameraUrlId: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "cameraUrlId", "cameraUrlId", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "cameraUrlId", false)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
